class calendarBlock {
    constructor() {

        let calendarBlockEl = document.getElementById('pollen-calendar-allergens-block');
        if (!calendarBlockEl) {
            return;
        }
        this.init();
    };

    async init() {
        let data = await this.fetchCalendarData();
        for (let dataitem in data) {
            var i = Object.keys(data).indexOf(dataitem)+1;
            console.log(i);
            console.log(dataitem);
            
            // if(dataitem == 'south_central'){
            console.log(data[dataitem]);

            // var topcheckboxArr = [];
            data[dataitem].forEach( item => {
                console.log(item);
                let itemName = item.name.replaceAll(' ', '-');
                let sesionLowcolore, sesionMidcolore, sesionHighcolore = '';

                switch (item.type) {
                case 'tree':
                    sesionLowcolore = '#E3EDC5';
                    sesionMidcolore = '#42C8A0';
                    sesionHighcolore = '#A9C23E';
                    break;
                case 'grass':
                    sesionLowcolore = '#D0EAC5';
                    sesionMidcolore = '#B7B39E';
                    sesionHighcolore = '#5E8954';
                    break;
                case 'weed':
                    sesionLowcolore = '#D1DCCF';
                    sesionMidcolore = '#60A9A2';
                    sesionHighcolore = '#7D998F';
                    break;
                case 'dust_mites':
                    sesionLowcolore = '#98C2E5';
                    sesionMidcolore = '#96BC56';
                    sesionHighcolore = '#445626';
                    break;
                case 'animal':
                    sesionLowcolore = '#C7DFA0';
                    sesionMidcolore = '#96BC56';
                    sesionHighcolore = '#445626';
                break;

                }

                var lowJson = '';
                if(item['low']){
                    lowJson = JSON.stringify(item['low']);
                }
                var highJson = '';
                if(item['high']){
                    highJson = JSON.stringify(item['high']);
                }

                document.getElementById('pollen-season__allergens-periods-wrapper_'+dataitem).innerHTML += `
                <div class="allergen__type--0 d-flex flex-column flex-md-row pollen-season__allergen ${item.type}-allergen w-100 list-pollen-${itemName}">
                        <span class="align-items-center d-flex pe-2 pe-lg-3 pollen-season__allergen--name ${item.type}-allergen text-start"><span class="me-lg-2 me-1 d-inline-block rounded-pill"></span>${item.name}</span>
                        <span class="flex-fill pollen-season__allergen--periods position-relative w-100">                        
                        ${this._creatHtml(`${item.type}-low-season`,`${lowJson}`, sesionLowcolore)}
                        ${this._creatHtml(`${item.type}-high-season`,`${highJson}`, sesionHighcolore)}
                        </span>
                    </div>
                `
            });

            let checkboxes = document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]');
            checkboxes.forEach( checkbox => {
                checkbox.addEventListener( 'change' , event => {                      
                    event.preventDefault();
                    document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show .pollen-season__allergen').forEach( ListEl => { 
                        ListEl.classList.add('d-none'); 
                        ListEl.classList.remove('d-flex'); 
                    });
                    if (document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]:checked').length > 0) {
                        document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]:checked').forEach( checkedEl => {
                            document.querySelectorAll(`.pollen-season__allergens-periods-wrapper.show .pollen-season__allergen.${checkedEl.value}-allergen`).forEach( ListEl =>{ 
                                ListEl.classList.remove('d-none'); 
                                ListEl.classList.add('d-flex'); 
                            });

                        });
                        if(document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]:checked').length < 4){
                            document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show').forEach( ListEl => { 
                            ListEl.classList.add('checked-allergen'); 
                            });
                        }
                        else{
                            document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show').forEach( ListEl => { 
                            ListEl.classList.remove('checked-allergen'); 
                            });
                        }
                    }
                    else {
                        document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show .pollen-season__allergen').forEach( ListEl => { 
                            ListEl.classList.remove('d-none'); 
                            ListEl.classList.add('d-flex'); 
                        });
                        document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show').forEach( ListEl => { 
                            ListEl.classList.remove('checked-allergen'); 
                        });
                    }                
                });
            });
            // }
        }

        let regTabs = document.querySelectorAll('[data-regtab]');
        regTabs.forEach( regTab => {
            regTab.addEventListener( 'click' , event => {                 
            var regTabVal = regTab.getAttribute('data-regtab');
            document.querySelectorAll('[data-regtab]').forEach( ListEl => { 
                ListEl.classList.remove('active'); 
            });
            document.querySelectorAll(`[data-regtab=${regTabVal}]`).forEach( ListEl =>{ 
                ListEl.classList.add('active'); 
            });
            document.querySelectorAll('.pollen-season__allergens-periods-wrapper').forEach( ListEl => { 
                ListEl.classList.add('d-none'); 
                ListEl.classList.remove('show'); 

                ListEl.classList.remove('checked-allergen'); 
            });
            document.querySelectorAll(`#pollen-season__allergens-periods-wrapper_${regTabVal}`).forEach( ListEl =>{ 
                ListEl.classList.remove('d-none'); 
                ListEl.classList.add('show'); 
            });

            document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]').forEach( checkbox => {
                checkbox.checked = false;
            });
            document.querySelectorAll('.pollen-season__allergens-periods-wrapper .pollen-season__allergen').forEach( ListEl => { 
                ListEl.classList.remove('d-none'); 
                ListEl.classList.add('d-flex'); 
            });
            });
        });        
    };

    
    _creatHtml(className,arr, color){
        let html=``;
        if(arr != ''){
            arr=JSON.parse(arr);
            arr.forEach(a_width => {
                let left = (((((a_width.start) - 1 ) / 48.0 ) * 100 )).toFixed(2);
                let width = (((a_width.end/48.0) * 100 ).toFixed(2)) - left;
                let tempHtml=`<span class="period low-season position-absolute ${className}" style="left:${left}%; width: ${width}%; background: ${color};"></span>`;
                html+=tempHtml
            });
        }
        return html;
    }

    async fetchCalendarData() {
        let data = [];
        await  fetch(`https://alk-app.klarify.me/api/pollen-calendar/allergens`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${window.klarifyAppToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
        .then(async (response) => {
            data.push(response.data.data);
        });

        return await data[0];
        
    }

}


typeof calendarBlock !== 'undefined' && new calendarBlock();